import { Tabs as LsTabs, Tab as LsTab } from 'components/common/Tabs'
import styled from '@emotion/styled'
import Box from '@mui/material/Box'

const StyledTabs = styled(LsTabs)`
  ${({ theme }) => `
    & .MuiTabs-indicatorSpan {
      position: absolute,
      max-width: 32px;
      width: 32px !important;
      border-radius: 2px;
      background: ${theme.palette.primary.main};
    }
  `}
`

export const TabsWrapper = styled(Box)`
  background-color: transparent;
  margin-bottom: 8px;
`

export const Tabs = (props) => {
  return (
    <StyledTabs
      {...props}
      variant="scrollable"
      scrollButtons="auto"
      textColor="primary"
      TabIndicatorProps={{
        children: <span className="MuiTabs-indicatorSpan" />,
        sx: {
          display: 'flex',
          justifyContent: 'center',
          background: 'transparent',
        },
      }}
    />
  )
}

export const StyledTab = styled(LsTab)`
  ${({ theme }) => `
    &.MuiTab-root {
      width: 64px;
      font-size: ${theme.typography.label.fontSize};
      font-weight: 700;
      padding: ${theme.spacing(0)};
      white-space: nowrap;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }
  `}
`

export const Tab = (props) => {
  return <StyledTab {...props} disableTouchRipple />
}
